import React from "react";
import Layout from "../../components/Layout/layout";
import house1 from "../../assets/inHouseCommittee/house1.jpg";
import house2 from "../../assets/inHouseCommittee/house2.jpg";
import house3 from "../../assets/inHouseCommittee/house3.jpg";
import house4 from "../../assets/inHouseCommittee/house4.jpg";

import house5 from "../../assets/inHouseCommittee/house5.jpg";

import house6 from "../../assets/inHouseCommittee/house6.jpg";

import house7 from "../../assets/inHouseCommittee/house7.jpg";

import house8 from "../../assets/inHouseCommittee/house8.jpg";

import house9 from "../../assets/inHouseCommittee/house9.jpg";

import house10 from "../../assets/inHouseCommittee/house10.jpg";

import house11 from "../../assets/inHouseCommittee/house11.jpg";

import house12 from "../../assets/inHouseCommittee/house12.jpg";

import house13 from "../../assets/inHouseCommittee/house13.jpg";

import house14 from "../../assets/inHouseCommittee/house14.jpg";

import house15 from "../../assets/inHouseCommittee/house15.jpg";

import house16 from "../../assets/inHouseCommittee/house16.jpg";

import house17 from "../../assets/inHouseCommittee/house17.jpg";
import InHouseCommitteeCard from "../../components/inHouseCommittee/InHouseCommitteeCard";

const inHouseCommittee = () => {
  const sortedMembers = [
    {
      img: house1,
      name: "Dr. Abhishek Verma",
      por: "IIT Guwahati",
    },
    {
      img: house2,
      name: "Prof. Akhilesh Kumar Maurya",
      por: "IIT Guwahati",
    },
    {
      img: house3,
      name: "Prof. Anjan Kumar S",
      por: "IIT Guwahati",
    },
    {
      img: house4,
      name: "Prof. Bulu Pradhan",
      por: "IIT Guwahati",
    },
    {
      img: house5,
      name: "Dr. Indu Siva Ranjani G",
      por: "IIT Guwahati",
    },
    {
      img: house6,
      name: "Dr. Kaling Taki",
      por: "IIT Guwahati",
    },
    {
      img: house7,
      name: "Prof. Kaustubh Dasgupta",
      por: "IIT Guwahati",
    },
    {
      img: house8,
      name: "Prof. Mallikarjuna C.",
      por: "IIT Guwahati",
    },
    {
      img: house9,
      name: "Dr. Nipjyoti Bharadwaj",
      por: "IIT Guwahati",
    },
    {
      img: house10,
      name: "Dr. RB. Sharmila",
      por: "IIT Guwahati",
    },
    {
      img: house11,
      name: "Dr. Romanbabu Oinam",
      por: "IIT Guwahati",
    },
    {
      img: house12,
      name: "Prof. Sandip Das",
      por: "IIT Guwahati",
    },
    {
      img: house13,
      name: "Dr. Santu Kar",
      por: "IIT Guwahati",
    },
    {
      img: house14,
      name: "Dr. Sparsh Johari",
      por: "IIT Guwahati",
    },
    {
      img: house15,
      name: "Prof. Sreedeep S.",
      por: "IIT Guwahati",
    },
    {
      img: house16,
      name: "Prof. Suresh A. Kartha",
      por: "IIT Guwahati",
    },
    {
      img: house17,
      name: "Dr. Vivek Padmanabha",
      por: "IIT Guwahati",
    },
  ];

  return (
    <Layout>
      <div className="bg-[#D7DDE1] py-10 ">
        <div className="w-full md:w-3/4 px-10 md:px-20 py-8 bg-white z-20 mb-[5vh] relative mx-auto">
          <div className="font-bold text-4xl text-[#1F7E95] pb-4">
            IN-HOUSE COMMITTEE
          </div>
          <div className="flex flex-wrap justify-between">
            {sortedMembers.map((speaker, index) => (
              <InHouseCommitteeCard
                img={speaker.img}
                name={speaker.name}
                por={speaker.por}
              />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default inHouseCommittee;
